import { render } from "./Footers.vue?vue&type=template&id=31818d48"
import script from "./Footers.vue?vue&type=script&lang=js"
export * from "./Footers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__